module.exports = __webpack_public_path__ + "img/ltkbuynow-3x.fad801a.jpg";